/**
 * [공통] 라우터
 * @module @helpers/router
 */

import router from '@/user/router'

/**
 * @alias module:@helpers/router
 * @method pathAccountApplied
 * @returns {string} 마이페이지의 교육신청 링크
 */
export const pathAccountApplied = () => '/account/applied'

/**
 * @alias module:@helpers/router
 * @method pathAccountApplied
 * @returns {string} 마이페이지의 교육완료 링크
 */
export const pathAccountCompleted = () => '/account/completed'

/**
 * @alias module:@helpers/router
 * @method pathAccountCertification
 * @returns {string} 마이페이지의 자격증 링크
 */
export const pathAccountCertificationExamApply = () => '/account/certification-apply'

/**
 * @alias module:@helpers/router
 * @method pathAccountCertification
 * @returns {string} 마이페이지의 자격증 링크
 */
export const pathAccountCertificationExamResult = () => '/account/certification-result'

/**
 * @alias module:@helpers/router
 * @method pathAccountCertification
 * @returns {string} 마이페이지의 자격증 링크
 */
export const pathAccountCertification = () => '/account/certification'

/**
 * @alias module:@helpers/router
 * @method gotoNotFound
 * @returns {promise} 찾을 수 없는 페이지 이동
 */
export const gotoNotFound = () => router.push('/notfound')

/**
 * @alias module:@helpers/router
 * @method gotoInternalServerError
 * @returns {promise} 서버 에러 페이지 이동
 */
export const gotoInternalServerError = () => router.push('/error')

export const gotoServiceUnavailable = () => {}
export const gotoNetworkError = () => {}

/**
 * Toast 로그인 페이지 이동
 * @alias module:@helpers/router
 * @method gotoToastIdLogin
 * @param {string} redirectUrl 리다이렉트 URL
 */
export const gotoToastIdLogin = (redirectUrl) => {
  location.href = `${process.env.VUE_APP_CLOUD_LOGIN_URL}?nextUrl=${encodeURIComponent(
    redirectUrl ? redirectUrl : window.location.origin
  )}`
}

/**
 * Cloud ID 페이지 및 하위 이동
 * @alias module:@helpers/router
 * @method navigateToCloudIdPath
 * @param {string} path 이동할 경로
 */
export const gotoCloudIdPath = (path) => {
  location.href = `${process.env.VUE_APP_CLOUD_ID_URL}${path}`
}

/**
 * @alias module:@helpers/router
 * @method gotoAttend
 * @returns {promise} 교육신청 페이지 이동
 */
export const gotoAttend = () => router.push('/attend')

export const gotoCertificationExamDate = () => router.push('/certification/date')

export const gotoCertificationSearch = () => router.push('/certification/search')

export const goToCertificationLevelDetails = (level) => router.push(`/certification/${level}`)

export default {
  pathAccountApplied,
  pathAccountCompleted,
  pathAccountCertification,
  pathAccountCertificationExamApply,
  pathAccountCertificationExamResult,
  gotoNotFound,
  gotoInternalServerError,
  gotoServiceUnavailable,
  gotoNetworkError,
  gotoToastIdLogin,
  gotoCloudIdPath,
  gotoAttend,
  gotoCertificationExamDate,
  gotoCertificationSearch,
  goToCertificationLevelDetails,
}
